var FormValidation = function () {
    var requiredClass = 'requiredError';
    var regexClass = 'regexError';
    var errorClasses = requiredClass + ' ' + regexClass;
    var errorMessageClass = 'error--text';
    var errorMessageContainer = '<span class="' + errorMessageClass + '"></span>';
    var parentErrorClass = 'has--error';
    var parentValidClass = 'is--valid';

    var _attach = function (id) {
        $('#' + id).on('change input', function () {
            _validate($(this));
        });
    };

    var _validate = function ($this) {
        var value = $this.val();
        var $parent = $this.parent();
        var required = $this.attr('data-requiredValidation') === 'true';
        var requiredMessage = $this.attr('data-requiredValidationMessage');
        var regex = $this.attr('data-regexValidation');
        var regexMessage = $this.attr('data-regexValidationMessage');

        if (value) {
            $this.removeClass(requiredClass);
            $parent.removeClass(parentErrorClass);
            $parent.removeClass(parentValidClass);

            if (regex && !value.match(regex)) {
                $this.addClass(regexClass);
                $parent.addClass(parentErrorClass);
                _setErrorMessage($this, regexMessage);
            } else {
                $this.removeClass(regexClass);
                $parent.addClass(parentValidClass);
                _setErrorMessage($this);
            }
        } else if (required) {
            $this.addClass(requiredClass);
            $parent.addClass(parentErrorClass);
            $parent.removeClass(parentValidClass);
            _setErrorMessage($this, requiredMessage);
        } else {
            $this.removeClass(errorClasses);
            $parent.removeClass(parentErrorClass);
            $parent.addClass(parentValidClass);
            _setErrorMessage($this);
        }
    };

    var _setErrorMessage = function ($this, message) {
        var $parent = $this.parent();
        var $messageContainer = $parent.find('.' + errorMessageClass);
        if (message) {
            if ($messageContainer.length) {
                $messageContainer.text(message);
            } else {
                $parent.append($(errorMessageContainer).text(message));
            }
        } else if ($messageContainer.length) {
            $messageContainer.remove();
        }
    };

    return {
        attach : _attach,
        validate : _validate
    };
}();